import image from './textures/texture-otis-redding.png'
// Theme
import { lighten, darken, invert } from 'polished'

const stripe = `rgb(210,230,240)`
const stripe_dark = darken(0.05, stripe)
const new_label = `#ff404c`
const white = 'white'

const main_color = `#442d6b`
const theme_app = `#80cab7`
const theme_color = `${lighten(0.6, main_color)}`
const inverted_theme = invert(`#442d6b`)
// Transparent colors
const color_transparent = `rgba(0,0,0,.1)`
const color_transparent_darker = `rgba(0,0,0,.2)`

// Label
const label_theme = `${lighten(0.3, main_color)}`
const label_border = `0px solid ${main_color}`
const label_hover_text = `${theme_color}`
// const label_box_shadow = `0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22)`
const label_box_shadow = ''

// Header
const header_theme = `${lighten(0.7, main_color)}`
const header_border = '1px solid rgba(0, 0, 0, 0.1)'

// Post
const post_highlight = `${lighten(0.15, main_color)}`
const post_highlight_text = `${lighten(0.7, main_color)}`
const post_code = `${darken(0.2, main_color)}`
const post_cover_box_shadow = `none`
const post_article_box_shadow = `none`

// Device breakpoints
const mobile = `screen and (max-width : 480px)`
const tablet = `screen and (min-device-width : 481px) and (max-device-width : 1024px)`
const desktop = `screen and (min-device-width : 1025px)`

// Text
const font_size = `1em`

// Margin
const margin_zero = `0em`
const margin_small = `9px`
const margin_medium = `18px`

// Border
const border_medium = `4px`
const border_radius_small = `5px`
const border_radius_large = `20px`

// Padding
const padding_zero = `0em`
const padding_small = `9px`
const padding_medium = `18px`

// Transition
const transition_time = `.5s`

// Text shadow
// const text_shadow_title = `5px 5px ${color_transparent}`
// const text_shadow_post_title = `0 5px 10px rgba(0,0,0,.3)`
const text_shadow_title = ''
const text_shadow_post_title = ''

// Box shadow
//const box_shadow = `0 3px 8px 0 rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.08)`
//const box_shadow_cover = `0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22)`
//const box_shadow_post = `15px 0px 20px 4px ${color_transparent}, -15px 0px 20px 4px ${color_transparent}`
const box_shadow = 0
const box_shadow_cover = 0
const box_shadow_post = 0

// Texture
const texture = `url(${image})`

const theme = {
  'theme-app': theme_app,
  'new-label': new_label,
  'inverted-theme': inverted_theme,
  'theme-color': theme_color,
  'main-color': main_color,
  white: white,
  'label-theme': label_theme,
  'label-border': label_border,
  'label-hover-text': label_hover_text,
  'label-box-shadow': label_box_shadow,
  'header-theme': header_theme,
  'header-border': header_border,
  'post-highlight': post_highlight,
  'post-highlight-text': post_highlight_text,
  'post-code': post_code,
  'post-cover-box-shadow': post_cover_box_shadow,
  'post-article-box-shadow': post_article_box_shadow,
  'color-transparent': color_transparent,
  'color-transparent-darker': color_transparent_darker,
  mobile,
  tablet,
  desktop,
  'font-size': font_size,
  'margin-zero': margin_zero,
  'margin-small': margin_small,
  'margin-medium': margin_medium,
  'border-medium': border_medium,
  'border-radius-small': border_radius_small,
  'border-radius-large': border_radius_large,
  'padding-zero': padding_zero,
  'padding-small': padding_small,
  'padding-medium': padding_medium,
  'transition-time': transition_time,
  'text-shadow-title': text_shadow_title,
  'text-shadow-post-title': text_shadow_post_title,
  'box-shadow': box_shadow,
  'box-shadow-cover': box_shadow_cover,
  'box-shadow-post': box_shadow_post,
  texture,
  stripe,
  'stripe-dark': stripe_dark,
}

export default theme
